import React, { useEffect, useState } from "react";
import AOS from "aos";
import "aos/dist/aos.css";
import "./Blog.css";

const blogPosts = [
  {
    title: "Jewelry Buying Guide",
    description: "Tips for choosing the perfect jewelry piece.",
    fullContent: "This is the full article content for Jewelry Buying Guide...",
    image: "/assets/blog-images/blogs-img1.webp",
  },
  {
    title: "Styling Tips & Trends",
    description: "Discover the latest jewelry trends and styling ideas.",
    fullContent: "This is the full article content for Styling Tips & Trends...",
    image: "/assets/blog-images/blogs-img2.webp",
  },
  {
    title: "Behind-the-Scenes Craftsmanship",
    description: "Explore how our jewelry is carefully handcrafted.",
    fullContent: "This is the full article content for Behind-the-Scenes Craftsmanship...",
    image: "/assets/blog-images/blogs-img3.webp",
  },
];

const Blog = () => {
  const [expandedPost, setExpandedPost] = useState(null);

  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  const handleReadMore = (index) => {
    setExpandedPost(expandedPost === index ? null : index);
  };

  return (
    <section className="blog-section">
      <h2 className="blog-title" data-aos="fade-up">Blog & Educational Content</h2>
      <div className="blog-container">
        {blogPosts.map((post, index) => (
          <div className="blog-card" key={index} data-aos="fade-up" data-aos-delay={index * 200}>
            <div className="blog-image-container">
              <img src={post.image} alt={post.title} className="blog-image" />
              <div className="blog-overlay">
                <p className="read-more" onClick={() => handleReadMore(index)}>
                  {expandedPost === index ? "Show Less" : "Read More"}
                </p>
              </div>
            </div>
            <div className="blog-content">
              <h3>{post.title}</h3>
              <p>{post.description}</p>
              {expandedPost === index && <p className="full-content">{post.fullContent}</p>}
            </div>
          </div>
        ))}
      </div>
    </section>
  );
};

export default Blog;
